let collection = document.getElementsByClassName("product-form");

for (let i = 0; i < collection.length; i++) {
  /*collection.item(i).style.fontSize ="24px";*/
  let result = collection.item.replace(/shipping/gi, "Test");
  collection.item(i).innerHTML = result;
}